import { buildCursorKey, compareCursorKeys } from './feedCursor';

export function feedItemKey(item = {}) {
    if (!item || !Number.isFinite(Number(item.id))) return null;
    return `${item._feedType === 'news' ? 'news' : 'article'}:${Number(item.id)}`;
}

export function itemCursorKey(item = {}) {
    if (!item) return null;
    return buildCursorKey(item.publishDate, item.id);
}

function stateCursorForItem(item, state = {}) {
    return item._feedType === 'news' ? state.newsCursorKey : state.articleCursorKey;
}

export function markNewItems(list = [], state = {}) {
    return list.map(item => {
        const cursor = itemCursorKey(item);
        const acknowledged = stateCursorForItem(item, state);
        return {
            ...item,
            _isNew: Boolean(cursor && acknowledged && compareCursorKeys(cursor, acknowledged) > 0),
        };
    });
}

export function summarizeNewItems(list = [], state = {}, pageLimit = 25) {
    const marked = markNewItems(list, state);
    const newerRows = marked.filter(item => item._isNew);
    const articleRows = marked.filter(item => item._feedType !== 'news');
    const newsRows = marked.filter(item => item._feedType === 'news');
    const newerArticles = newerRows.filter(item => item._feedType !== 'news');
    const newerNews = newerRows.filter(item => item._feedType === 'news');
    const newestArticle = newerArticles.reduce((newest, item) => (
        compareCursorKeys(itemCursorKey(item), itemCursorKey(newest)) > 0 ? item : newest
    ), null);
    const newestNews = newerNews.reduce((newest, item) => (
        compareCursorKeys(itemCursorKey(item), itemCursorKey(newest)) > 0 ? item : newest
    ), null);
    const articleCapped = Boolean(state.articleCursorKey)
        && articleRows.length >= pageLimit
        && articleRows.length === newerArticles.length;
    const newsCapped = Boolean(state.newsCursorKey)
        && newsRows.length >= pageLimit
        && newsRows.length === newerNews.length;

    return {
        count: newerRows.length,
        capped: articleCapped || newsCapped,
        newestArticleId: newestArticle?.id || null,
        newestNewsId: newestNews?.id || null,
        newestArticleCursorKey: newestArticle ? itemCursorKey(newestArticle) : null,
        newestNewsCursorKey: newestNews ? itemCursorKey(newestNews) : null,
    };
}

export function mergeEngagementWithoutNewRows(current = [], refreshed = []) {
    const refreshedByKey = new Map(refreshed.map(item => [feedItemKey(item), item]));
    return current.map(item => {
        const replacement = refreshedByKey.get(feedItemKey(item));
        return replacement ? { ...item, ...replacement } : { ...item };
    });
}

export function mergePendingPage(first = [], second = []) {
    const result = [];
    const seen = new Set();
    [...first, ...second].forEach(item => {
        const key = feedItemKey(item);
        if (!key || seen.has(key)) return;
        seen.add(key);
        result.push({ ...item });
    });
    return result;
}
